<template>
  <div id="sig_container" class="full form-horizontal">
    <div class="widget">
      <div
        class="
          widget-content widget-content-mini
          themed-background-info
          text-light-op
        "
      >
        <span class="float-right text-muted"><i class="fa fa-check"></i></span
        >Configuración de busqueda
      </div>
      <div
        class="widget-content border-bottom themed-background-muted text-center"
      >
        <div class="form-group row">
          <label
            class="col-form-label col-lg-2 col-md-1"
            v-text="'Cedula:'"
          ></label>
          <div class="col-lg-9 col-md-10">
            <input
              type="text"
              class="form-control"
              v-model="cedula"
              placeholder="Escriba la cédula"
            />
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-10">
            <button
              type="submit"
              @click="buscar"
              class="btn btn-primary mx-auto"
              :disabled="usuariosLoading"
              v-text="!usuariosLoading ? 'Buscar' : 'Buscando'"
            ></button>
          </div>
        </div>

        <table-component @click-event="clickEvent" :data="usuarios">
          <table-column
            slot="label"
            :label="'Cedula'"
            v-bind:value="'id_cliente'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Email'"
            v-bind:value="'email'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Nombre'"
            v-bind:value="'nombre'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Celular'"
            v-bind:value="'celular'"
          ></table-column>
          <table-column slot="label" :label="'Acciones'" :icon="'fa'">
            <template
              slot="icon"
              :icon="'fa fa-edit'"
              :class="'btn btn-sm btn-primary'"
              :slug="'editar-password-usuario'"
              :tooltip="'Editar password Usuario'"
            ></template>
            <template
              slot="icon"
              :icon="'fas fa-user-edit'"
              :class="'btn btn-sm btn-primary'"
              :slug="'actualizar-datos-usuario'"
              :tooltip="'Actualizar datos'"
            ></template>
          </table-column>
        </table-component>
      </div>
    </div>
    <!-- modal -->
    <modal
      class="modal fade"
      v-model="modalPassword"
      ref="modal-password"
      id="modal-password"
    >
      <template>
        <div class="loader" v-if="usuariosLoading">
          <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
        </div>
        <template slot="header">
          <h4 class="modal-title">Cambiar contraseña</h4>
          <button
            type="button"
            aria-label="Close"
            class="close"
            style="position: relative; z-index: 1060"
            @click="cerrarModalPassword()"
          >
            <span aria-hidden="true">×</span>
          </button>
        </template>
        <form class="form-horizontal">
          <div class="form-group">
            <label
              class="col-form-label col-lg-6 col-md-6 text-left"
              v-text="'Nueva contraseña:'"
            ></label>
            <div class="col-lg-9 col-md-10">
              <input
                type="password"
                class="form-control"
                id="validPassword"
                v-model="password"
                placeholder="Escriba la clave"
                required
              />
            </div>
          </div>

          <div class="form-group">
            <label
              class="col-form-label col-lg-6 col-md-6 text-left"
              v-text="'Confirmar contraseña:'"
            ></label>
            <div class="col-lg-9 col-md-10">
              <input
                type="password"
                class="form-control"
                :class="{ 'is-invalid': isValidPassword }"
                v-model="confimPassword"
                placeholder="Confirme la clave"
              />
              <div class="invalid-feedback" v-text="isValidPassword"></div>
            </div>
          </div>
        </form>
        <template slot="footer">
          <btn
            type="button"
            class="btn btn-danger"
            @click="cerrarModalPassword()"
            >Cerrar</btn
          >&nbsp;
          <btn
            :disabled="isActiveBtnChangePassword"
            @click="cambiarPassword"
            type="button"
            class="btn btn-info"
            v-text="!usuariosLoading ? 'Cambiar' : 'Cambiando'"
          ></btn>
        </template>
      </template>
    </modal>
    <!-- fin  modal -->
    <!-- fin  modal datos user-->
    <modal
      class="modal fade"
      v-model="modal"
      ref="modal-data-user"
      id="modal-data-user"
    >
      <template>
        <div class="loader" v-if="usuariosLoading">
          <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
        </div>
        <template slot="header">
          <h4 class="modal-title">Actualizar datos</h4>
          <button
            type="button"
            aria-label="Close"
            class="close"
            style="position: relative; z-index: 1060"
            @click="cerrarModal()"
          >
            <span aria-hidden="true">×</span>
          </button>
        </template>
        <form class="form-horizontal">
          <div class="form-group">
            <label
              class="col-form-label col-lg-6 col-md-6 text-left"
              v-text="'Nuevo número de celular:'"
            ></label>
            <div class="col-lg-9 col-md-10">
              <input
                type="text"
                class="form-control"
                v-model="celular"
                placeholder="Escriba el celular"
                required
              />
            </div>
          </div>


          <div class="form-group">
            <label
              class="col-form-label col-lg-6 col-md-6 text-left"
              v-text="'nuevo correo eletronico:'"
            ></label>
            <div class="col-lg-9 col-md-10">
              <input
                type="text"
                class="form-control"
                v-model="email"
                placeholder="Escriba el email"
              />
            </div>
          </div>
        </form>
        <template slot="footer">
          <btn type="button" class="btn btn-danger" @click="cerrarModal()"
            >Cerrar</btn
          >&nbsp;
          <btn
            @click="actualizarDatos"
            type="button"
            class="btn btn-info"
            v-text="!usuariosLoading ? 'Cambiar' : 'Cambiando'"
          ></btn>
        </template>
      </template>
    </modal>
    <!-- fin  modal -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import bcrypt from "bcryptjs";
import sha512 from "sha512";

export default {
  name: "usuarios-appSdeudores",
  components: {
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      usuarios: "usuariosDeudores/usuarios",
      usuariosLoading: "usuariosDeudores/loading",
    }),
    isValidPassword() {
      if (this.password != this.confimPassword) {
        return "no coiciden las claves";
      } else {
        return "";
      }
    },
    isActiveBtnChangePassword() {
      if (this.password && this.confimPassword) {
        return this.isValidPassword == "" ? false : true;
      } else {
        return true;
      }
    },
  },
  data() {
    return {
      cedula: "",
      password: "",
      confimPassword: "",
      modalPassword: false,
      modal: false,
      garantia: "",
      email: "",
      celular: "",
    };
  },
  methods: {
    clickEvent(data, slug) {
      switch (slug) {
        case "editar-password-usuario":
          if (!data.registrado) {
            this.$notify({
              title: "Advertencia!",
              type: "danger",
              content: "Usuario no registrado en la app.",
            });
            return;
          }
          this.modalPassword = true;
          this.cedula = data.id_cliente;
          break;
        case "actualizar-datos-usuario":
          this.modal = true;
          this.id_garantia = data.id_garantia;
          this.email = data.email;
          this.celular = data.celular? data.celular:"";
          break;
        default:
          break;
      }
    },
    buscar() {
      try {
        this.$store.dispatch("usuariosDeudores/search", {
          id_cliente: this.cedula,
        });
      } catch (e) {
        this.$notify({
          title: "Advertencia!",
          type: "danger",
          content: "Se ha presentado un error realizando su consulta",
        });
      }
    },
    cerrarModalPassword() {
      this.modalPassword = false;
    },
    cerrarModal() {
      this.modal = false;
    },
    cambiarPassword() {
      var pass = sha512(this.password).toString("hex");
      pass = new Promise((resolve) =>
        bcrypt.hash(pass, 12, (err, hash) => {
          resolve(hash);
        })
      ).then((hash) => {
        try {
          this.$store
            .dispatch("usuariosDeudores/changePasswod", {
              id_cliente: this.cedula,
              new_password: hash,
              password_confirm: hash,
            })
            .then(() => {
              this.cerrarModalPassword();
              this.password = "";
              this.confimPassord = "";
              this.$notify({
                title: "Cambio realizado!",
                type: "success",
                content: "se ha cambiado la clave correctamete",
              });
            })
            .catch(() => {
              this.$notify({
                title: "Advertencia!",
                type: "danger",
                content:
                  "Se ha presentado un error realizando el cambio de clave.",
              });
              this.cerrarModalPassword();
            });
        } catch (e) {
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "Se ha presentado un error realizando el cambio de clave",
          });
          this.cerrarModalPassword();
        }
      });
    },
    actualizarDatos() {
      try {
        this.$store
          .dispatch("usuariosDeudores/update", {
            id_garantia: this.id_garantia,
            celular: this.celular,
            email: this.email,
          })
          .then(() => {
            this.cerrarModal();
            this.celular = "";
            this.email = "";
            this.$notify({
              title: "Cambio realizado!",
              type: "success",
              content: "se ha actualizado los datos",
            });
            this.buscar();
          })
          .catch(() => {
            this.$notify({
              title: "Advertencia!",
              type: "danger",
              content:
                "Se ha presentado un error realizando la actualizacion de los datos",
            });
            this.cerrarModal();
          });
      } catch (e) {
        this.$notify({
          title: "Advertencia!",
          type: "danger",
          content:
            "Se ha presentado un error realizando la actualizacion de los datos",
        });
        this.cerrarModal();
      }
    },
  },
};
</script>
<style scoped>
.loader {
  width: 70%;
}
.fade:not(.show)#modal-password {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-header {
  display: block;
}

.modal-title {
  font-weight: bold;
}

.fade:not(.show)#modal-data-user {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>